import React from 'react';
import { Alert } from 'antd';

export const BUSY_NOTICE_STRINGS = {
  title: 'Some reports may load slowly or fail to load',
  description:
    "We're experiencing higher-than-expected load and are working on a fix. We're sorry for the inconvenience. Please check back later.",
} as const;

const PROSE_MAX_WIDTH_PX = 640;

function SearchPerformanceBusyNotice() {
  return (
    <Alert
      type="warning"
      showIcon
      role="status"
      aria-live="polite"
      message={BUSY_NOTICE_STRINGS.title}
      description={
        <span style={{ display: 'block', maxWidth: PROSE_MAX_WIDTH_PX }}>{BUSY_NOTICE_STRINGS.description}</span>
      }
    />
  );
}

export default SearchPerformanceBusyNotice;
